import type { FC } from "react";

type PatientProfilePartProps = {
  title: string;
  children: React.ReactNode;
};

const PatientProfilePart: FC<PatientProfilePartProps> = ({
  title,
  children,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="text-xs text-gray-600 uppercase">{title}</div>
      <div>{children}</div>
    </div>
  );
};

export default PatientProfilePart;
